export default __webpack_public_path__ + "static/media/select_arrow.56f6a7f7.svg";